'use client'

import { useTranslations } from 'next-intl'
import { Link } from '@/i18n/routing'
import { Button } from '@/components/ui/button'

export default function NotFoundPage() {
  const t = useTranslations('errors')

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="text-center space-y-4 max-w-md">
        <p className="text-6xl font-bold text-muted-foreground">404</p>
        <h1 className="text-2xl font-semibold text-foreground">{t('pageNotFound')}</h1>
        <p className="text-muted-foreground">{t('pageNotFoundDesc')}</p>
        <Button asChild>
          <Link href="/sites">{t('backToSites')}</Link>
        </Button>
      </div>
    </div>
  )
}
